import { createContext } from 'react';

import { type MapContext } from './types';

export const mapContext = createContext<MapContext>(undefined as unknown as MapContext);
